import type { Feedback, Tutor } from '@brighterly/lib-core-types/tutor/interfaces'
import type { DisciplineStore } from '@stores/discipline/interfaces'

import { getDisciplineDemo, getDisciplineInfo } from '@stores/discipline/getters'

const getTutor = (state: DisciplineStore): Tutor | null => getDisciplineInfo(state)?.tutor || null

const getTutorName = (state: DisciplineStore): string => getTutor(state)?.first_name || ''

const getTutorAvatarUrl = (state: DisciplineStore): string | null => getTutor(state)?.avatar_url || null

const getTutorFeedback = (state: DisciplineStore): Feedback | null => getDisciplineDemo(state)?.tutor_feedback || null

const isTutorPremium = (state: DisciplineStore): boolean => getDisciplineInfo(state)?.is_premium || false

const isTutorFeedbackCompleted = (state: DisciplineStore): boolean => !!getDisciplineDemo(state)?.tutor_feedback

const getTutorInformation = (state: DisciplineStore): string | null => getTutor(state)?.information || null

const getCustomerComment = (state: DisciplineStore): string | null => getTutor(state)?.customer_comment || null

const getTutorRating = (state: DisciplineStore): number | null => getTutor(state)?.rating || null

const getTutorCompletedLessons = (state: DisciplineStore): number | null => getTutor(state)?.completed_lessons || null

export const tutor = {
  getTutor: (state: DisciplineStore): Tutor | null => getTutor(state),
  getTutorName: (state: DisciplineStore): string => getTutorName(state),
  getTutorAvatarUrl: (state: DisciplineStore): string | null => getTutorAvatarUrl(state),
  getTutorFeedback: (state: DisciplineStore): Feedback | null => getTutorFeedback(state),
  getTutorInformation: (state: DisciplineStore): string | null => getTutorInformation(state),
  getCustomerComment: (state: DisciplineStore): string | null => getCustomerComment(state),
  getTutorRating: (state: DisciplineStore): number | null => getTutorRating(state),
  getTutorCompletedLessons: (state: DisciplineStore): number | null => getTutorCompletedLessons(state),
  isTutor: (state: DisciplineStore): boolean => !!getTutor(state),
  isTutorAvatarUrl: (state: DisciplineStore): boolean => !!getTutorAvatarUrl(state),
  isTutorFeedback: (state: DisciplineStore): boolean => !!getTutorFeedback(state),
  isTutorPremium: (state: DisciplineStore): boolean => isTutorPremium(state),
  isTutorFeedbackCompleted: (state: DisciplineStore): boolean => isTutorFeedbackCompleted(state),
  isTutorInformation: (state: DisciplineStore): boolean => !!getTutorInformation(state),
  isTutorRating: (state: DisciplineStore): boolean => !!getTutorRating(state),
  isTutorCompletedLessons: (state: DisciplineStore): boolean => !!getTutorCompletedLessons(state),
  isCustomerComment: (state: DisciplineStore): boolean => !!getCustomerComment(state),
}

